/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import theme from '@/constants/theme';
import Markdown from 'react-markdown';

interface MarkdownReaderProps {
  children: string;
}

export const MarkdownReader: React.FC<MarkdownReaderProps> = ({ children }) => {
  if (!children) {
    console.error('No hay contenido por mostrar.');
    return null;
  }
  return (
    <Markdown
      components={{
        p: ({ node, ...props }) => (
          <p style={{ color: theme.colors.text.body, paddingBlock: '0.2lh' }} {...props} />
        ),
        h1: ({ node, ...props }) => (
          <h1 style={{ marginBottom: 8, marginTop: 8, color: theme.colors.text.title }} {...props} />
        ),
        h2: ({ node, ...props }) => (
          <h2 style={{ marginBottom: 8, marginTop: 8, color: theme.colors.text.title }} {...props} />
        ),
        h3: ({ node, ...props }) => (
          <h3 style={{ marginBottom: 8, marginTop: 8, color: theme.colors.text.title }} {...props} />
        ),
        h4: ({ node, ...props }) => (
          <h4 style={{ marginBottom: 8, marginTop: 8, color: theme.colors.text.title }} {...props} />
        ),
        h5: ({ node, ...props }) => (
          <h5 style={{ marginBottom: 8, marginTop: 8, color: theme.colors.text.title }} {...props} />
        ),
        h6: ({ node, ...props }) => (
          <h6 style={{ marginBottom: 8, marginTop: 8, color: theme.colors.text.title }} {...props} />
        ),
        li: ({ node, ...props }) => (
          <li style={{ color: theme.colors.text.body, paddingBlock: '0.2lh' }} {...props} />
        ),
        ul: ({ node, ...props }) => (
          <ul
            style={{
              color: theme.colors.text.body,
              listStylePosition: 'outside',
              marginLeft: '1.2rem',
            }}
            {...props}
          />
        ),
        ol: ({ node, ...props }) => (
          <ol
            style={{
              color: theme.colors.text.body,
              listStyleType: 'decimaL',
              listStylePosition: 'outside',
              marginLeft: '1.2rem',
            }}
            {...props}
          />
        ),
        a: ({ children, ...props }) => (
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: theme.colors.primary,
              textDecoration: 'underline',
            }}
            {...props}
          >
            {children}
          </a>
        ),
      }}
    >
      {children}
    </Markdown>
  );
};
